import { useEffect, useMemo, useState } from 'react';
import { loadEmbeddedScript } from '../services/utils';

const useInjectScript = ({ id, src }) => {
  const [isLoaded, setLoaded] = useState(false);
  const scriptSrc = useMemo(() => (src), [src]);
  const scriptId = useMemo(() => (id), [id]);
  const scriptAsync = true;
  const scriptDefer = true;

  function onLoad() {
    setLoaded(true);
  }

  useEffect(() => {
    loadEmbeddedScript({
      onLoadCallback: onLoad,
      scriptAsync,
      scriptDefer,
      scriptId,
      scriptSrc,
    });

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [scriptAsync, scriptDefer, scriptId, scriptSrc]);

  return isLoaded;
};

export { useInjectScript };
